import React from "react";
import Navbar from "../../Components/Navbar";
import "./style.css";
import Craousel from "../../Components/Carousel/index";
import Footer from "../../Components/Footer/index";

import { useAuthContext } from "../../hooks";
function Index() {
  const auth = useAuthContext();

  console.log("user info", auth?.userInfo?.id);
  const navbarFunc = () => {
    return auth?.userInfo?.is_admin;
  };
  const seState = navbarFunc();
  console.log("navbar value", seState);
  return (
    <div className="home-whole-container">
      <div className="home-card">
        <div className="home-page-content">
          <div className="home-page-container">
            <div className="slider">
              <div className="carouse-Blogs-events">
                <Craousel />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-class">
        <Footer />
      </div>
    </div>
  );
}

export default Index;
